import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=5c6bb298&scoped=true&"
import script from "./privacyPolicy.vue?vue&type=script&lang=js&"
export * from "./privacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=5c6bb298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6bb298",
  null
  
)

export default component.exports